import React from "react"
import { Container } from "react-bootstrap"
import StatCard from "./StatCard"
import "./StatsListing.scss"

const StatsListingModule = ({ module }) => {
  let theme = module?.Stats_Theme ? `${module?.Stats_Theme}` : 'section-m'

  return (
    <div className={`${theme} stats-wrapper`}>
      <Container className="stats-container">
        <h2 className="heading">{module.Stats_Heading}</h2>
        {module.Stats_Description && (
          <p className="description">{module.Stats_Description}</p>
        )}
        <div
          className={`stats-section ${
            module?.Stats_List?.length < 4 ? "stats-section-alt" : ""
          }`}
        >
          {module?.Stats_List.map(statItem => (
            <StatCard statItem={statItem} />
          ))}
        </div>
        {module?.Stats_Heading == "Our Property Management Includes:" &&
            <div className="stats-btn">
              <a href="https://davidastburys.fixflo.com/" target="_blank" className="btn btn-fill-primary">
                Report a Maintenance
              </a>
            </div>
        }
      </Container>
    </div>
  )
}

export default StatsListingModule
